<script>
import axios from "axios";
import { layoutMethods, layoutComputed } from "@/state/helpers";
import simplebar from "simplebar-vue";
import { cartMethods, cartComputed } from "@/state/helpers";

export default {
  components: {
    simplebar,
  },
  data() {
    return {
      config: {
        handler: this.handleRightBarClick,
        middleware: this.middleware,
        events: ["click"],
      },
    };
  },
  methods: {
    ...layoutMethods,
    ...cartMethods,
    hide() {
      this.$parent.toggleRightSidebar();
    },
    handleRightBarClick() {
      this.$parent.hideRightSidebar();
    },
    middleware(event) {
      if (event.target.classList)
        return !event.target.classList.contains("toggle-right");
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
  },
  mounted() {
    this.fetchCarts();
  },
  computed: {
    ...layoutComputed,
    ...cartComputed,
    cart_total(){ var total = 0; this.carts.forEach((item)=>{ var item_total = item.product.price*item.quantity; total = total+item_total;}); return total },
  },
};
</script>

<template>
  <div>
    <div v-click-outside="config" class="right-bar">
      <simplebar class="h-100"> 
        <div class="rightbar-title px-3 py-4">
          <h4 class="m-0"><i class="bx bx-cart-alt fa-1x"></i> Cart</h4>
        </div>
        <div v-if="carts.length>0" class="p-3">
          <hr class="mt-1" />          
            <div v-for="data in carts" :key="data.id">
              <div class="row p-2">
                <div class="col-3">
                    <img :src="getFiles(data.product.photo)" height="50px"/>
                </div>
                <div class="col-6 ms-3">
                  <span class="text-truncate">{{ data.product.name }}</span>
                  <h6 class="my-0"><b>AED {{commas( data.product.price) }}</b></h6>
                  <span class="my-0">Quantity: {{ data.quantity }}</span>
                </div>
                <div class="col-2">
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
              </div>
            </div>
          </div>
          <hr class="mt-1" />
          <span class="my-3">Total: <b class="h4">{{ commas(cart_total) }}</b> AED</span>

          <div class="mt-3 d-flex justify-content-between">
            <router-link tag="a" to="/cart" class="btn btn-sm btn-success" >View Cart</router-link>
            <router-link tag="a" to="/checkout" class="btn btn-sm btn-outline-success ms-2" >Checkout</router-link>
          </div>
        </div>
        <div v-else class="text-center p-5 h6">
          <i class="fas fa-shopping-cart fa-4x"></i>
          Empty Cart<br><br>
          <router-link tag="a" to="/products" class="btn btn-sm btn-success" >View Services</router-link>

        </div>
      </simplebar>
    </div>

    <!-- Right bar overlay-->
    <div class="rightbar-overlay"></div>
  </div>
</template>
